export default __webpack_public_path__ + "static/media/Bank.3be9a19f.png";